import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import {
  ActivityLogFilter,
  ActivityLogPagination,
  ActivityLogViewModel,
} from '@keeps-platform-frontend-workspace/kp-keeps';
import { KpActivityLogHeaderComponent } from '@keeps-platform-frontend-workspace/ui/kp-activity-log-header';
import { KpActivityLogListComponent } from '@keeps-platform-frontend-workspace/ui/kp-activity-log-list';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ActivityLogActions, activityLogFeature } from './store';

@Component({
  selector: 'app-activity-log',
  imports: [CommonModule, TranslocoModule, KpActivityLogHeaderComponent, KpActivityLogListComponent],
  template: `
    @if (vm$ | async; as vm) {
      <kp-activity-log-header
        [options]="vm.filterOptions"
        (searchFilter)="filterByTerm($event)"
        (filter)="onFilter($event)"
      ></kp-activity-log-header>
      <kp-activity-log-list
        class="grow"
        [vm]="vm"
        (pageChanged)="onPageChange($event)"
        (export)="onExport($event)"
      ></kp-activity-log-list>
    }
  `,
  styles: [
    `
      :host {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityLogComponent implements OnDestroy {
  vm$: Observable<ActivityLogViewModel>;

  constructor(private store: Store) {
    this.store.dispatch(ActivityLogActions.init());
    this.vm$ = store.select(activityLogFeature.selectViewModel);
  }

  ngOnDestroy(): void {
    this.store.dispatch(ActivityLogActions.resetState());
  }

  filterByTerm(search: string): void {
    this.store.dispatch(ActivityLogActions.filterByTerm({ search }));
  }

  onFilter(filter: ActivityLogFilter): void {
    this.store.dispatch(ActivityLogActions.setFilter({ filter }));
  }

  onPageChange(pagination: Partial<ActivityLogPagination>): void {
    this.store.dispatch(ActivityLogActions.setPagination({ pagination }));
  }

  onExport(id: string): void {
    this.store.dispatch(ActivityLogActions.exportLog({ id }));
  }
}
